import { Observable } from "rxjs";

export interface IDateService {
  getDateFormat(isUpperCase?: boolean) : Observable<string>;
}

export const DATE_SERVICE_INTERFACE = 'IDateService';
